<template>
  <v-simple-table dense class="w-100">
    <template #default>
      <thead class="table-heading">
        <tr class="font-weight-bold">
          <th class="text-center text-dark font-weight-bold text-capitalize">
            Pedidos {{ period }}
          </th>
          <th class="text-center text-dark font-weight-bold">
            Pedidos facturados
          </th>
          <th class="text-center text-dark font-weight-bold">
            Pedidos pendientes
          </th>
          <th class="text-center text-dark font-weight-bold">
            Pedidos Rechazados
          </th>
        </tr>
      </thead>
      <tbody v-if="hasErrors">
        <tr>
          <td colspan="4">
            <alert-prominent
              :with-action="true"
              :max-clicks="5"
              @click="$emit('refresh')"
            />
          </td>
        </tr>
      </tbody>
      <tbody v-else class="text-body-2 tbody-border-1">
        <tr class="pa-3">
          <td>
            <b
              >{{ formatNumber(items.totalOrders, '', 0) }} <br />
              {{ formatNumber(items.totalAmountOrders, '$', 0) }}</b
            >
          </td>
          <td>
            {{ formatNumber(items.totalInvoices, '', 0) }}<br />
            {{ formatNumber(items.totalAmountInvoices, '$', 0) }}
          </td>
          <td class="py-3">
            <v-row no-gutters class="text-left">
              <v-col cols="5">Creado</v-col>
              <v-col cols="3" class="text-center font-weight-bold">{{
                formatNumber(items.ordersCreated, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right font-weight-bold">
                {{ formatNumber(items.ordersCreatedAmount, '$', 0) }}
              </v-col>
            </v-row>
            <v-row no-gutters class="text-left">
              <v-col cols="5">En tratamiento</v-col>
              <v-col cols="3" class="text-center font-weight-bold">{{
                formatNumber(items.ordersInTreatment, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right font-weight-bold">
                {{ formatNumber(items.ordersInTreatmentAmount, '$', 0) }}
              </v-col>
            </v-row>
            <v-row no-gutters class="text-left">
              <v-col cols="5">Bloqueado por crédito</v-col>
              <v-col cols="3" class="text-center font-weight-bold">{{
                formatNumber(items.ordersBlockedByCredit, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right font-weight-bold">
                {{ formatNumber(items.ordersBlockedByCreditAmount, '$', 0) }}
              </v-col>
            </v-row>
            <v-row no-gutters class="text-left">
              <v-col cols="5">Facturado parcial</v-col>
              <v-col cols="3" class="text-center font-weight-bold">{{
                formatNumber(items.ordersPartiallyInvoiced, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right font-weight-bold">
                {{ formatNumber(items.ordersPartiallyInvoicedAmount, '$', 0) }}
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3 font-weight-bold">
              <v-col cols="5" class="text-right">Total</v-col>
              <v-col cols="3" class="text-center">{{
                formatNumber(items.totals?.pendingOrders, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right">{{
                formatNumber(items.totals?.pendingOrdersAmount, '$', 0)
              }}</v-col>
            </v-row>
          </td>
          <td>
            <v-row
              v-for="(item, index) in items.rejectedOrdersReason"
              :key="index"
              no-gutters
              class="text-left"
            >
              <v-col cols="6">{{ item.description }}</v-col>
              <v-col cols="2" class="text-center font-weight-bold">{{
                formatNumber(item.count, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right font-weight-bold">{{
                formatNumber(item.amount, '$', 0)
              }}</v-col>
            </v-row>
            <v-row no-gutters class="mt-3 font-weight-bold">
              <v-col cols="6" class="text-right">Total </v-col>
              <v-col cols="2" class="text-center">{{
                formatNumber(items.totals?.rejectedOrders, '', 0)
              }}</v-col>
              <v-col cols="4" class="text-right">{{
                formatNumber(items.totals?.rejectedOrdersAmount, '$', 0)
              }}</v-col>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  import DateFormats from '@/core/constants/DateFormats';
  import dates from '@/mixins/dates';
  import AlertProminent from '@/components/AlertProminent.vue';
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'OrdersTable',
    components: { AlertProminent },
    mixins: [dates, numbersFormats],
    props: {
      items: {
        type: Object,
        default: () => ({}),
      },
      hasErrors: Boolean,
    },
    computed: {
      period() {
        return this.items
          ? this.removeTimeFromDate(
              this.items.period,
              DateFormats.YEAR_MONTH,
              DateFormats.MONTH_YEAR
            )
          : '';
      },
    },
  };
</script>
